import React, { useEffect } from 'react';
import Page from './../../components/Page';
import { observer } from 'mobx-react-lite';
import Paths from '../../constants/paths';
import Matches from '../Matches/Matches';
import { Route } from 'react-router-dom';
import NewMatch from '../Matches/NewMatch';
import Match from '../Matches/Match';

const PreseasonTab = ({ store }) => {
    useEffect(() => {
        let joinBy = ['league'];
        let fetchAll = true;
        //league_id, add_unknown, joinBy, fetch-all
        store.getTeams(undefined, true, joinBy, fetchAll);
    }, [store]);

    return (
        <Page>
            <Route exact path={Paths.PRESEASON_MATCHES}>
                <Matches store={store} isPreseason={true} />
            </Route>
            <Route exact path={Paths.PRESEASON_MATCH}>
                <Match store={store} isPreseason={true} />
            </Route>
            <Route exact path={Paths.PRESEASON_MATCHES_NEW}>
                <NewMatch store={store} isPreseason={true} showLeagues={true} />
            </Route>
        </Page>
    );
};

export default observer(PreseasonTab);
